import type { Category } from '@repo/types';

export const getSectionPriorityByTitle = (
  keyInsightsSections?: Array<{ display_title: string; priority?: number }>,
) => {
  const map = new Map<string, number>();
  if (!keyInsightsSections?.length) return map;

  for (const section of keyInsightsSections) {
    if (typeof section.priority === 'number') {
      map.set(section.display_title, section.priority);
    }
  }

  return map;
};

export const orderCategoriesBySectionPriority = (
  categories: Category[],
  sectionPriorityByTitle: Map<string, number>,
): Category[] => {
  if (!categories.length || !sectionPriorityByTitle.size) return categories;

  const originalIndex = new Map(categories.map((category, idx) => [category.name, idx]));

  return [...categories].sort((a, b) => {
    const aPriority = sectionPriorityByTitle.get(a.name);
    const bPriority = sectionPriorityByTitle.get(b.name);

    if (typeof aPriority === 'number' && typeof bPriority === 'number') {
      if (aPriority !== bPriority) return bPriority - aPriority;
    } else if (typeof aPriority === 'number') {
      return -1;
    } else if (typeof bPriority === 'number') {
      return 1;
    }

    return (originalIndex.get(a.name) ?? 0) - (originalIndex.get(b.name) ?? 0);
  });
};
